module.exports = __webpack_public_path__ + "img/weddingrings-mobile.8babd9f.jpg";